@if (enabledFeatures$ | async; as features) {
  @if (features.length > 0) {
    <div class="flex min-h-0 flex-1 flex-col">
      @if (features.length > 1) {
        <header class="border-b border-slate-200 bg-white px-6 py-3">
          <nav class="flex gap-1">
            @for (feature of features; track feature.id) {
              <a
                class="flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-medium text-slate-500 transition-colors hover:bg-slate-50 hover:text-slate-700"
                routerLinkActive="section-link-active"
                [routerLink]="feature.id"
              >
                <mat-icon class="icon-xs">{{ feature.icon }}</mat-icon>
                <span>{{ feature.label }}</span>
              </a>
            }
          </nav>
        </header>
      }

      <main class="flex-1 overflow-auto">
        <router-outlet />
      </main>
    </div>
  } @else {
    <div class="flex items-center justify-center p-12">
      <p class="text-sm text-slate-400">
        No AI features are available for this workspace.
      </p>
    </div>
  }
}
